module.exports = __webpack_public_path__ + "v1.0.0/img/app-menue-icon.6dfff9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/style/images/menu/app-menue-icon.png
// module id = i5jt
// module chunks = 1